import React, { useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../../Layout";
import { Data } from "../../../store/terminal/types";
import { getById } from "../../../store/terminal/queries";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import { fetchRequest as fetchTerminalDetail } from "../../../store/terminal/actions";
import TerminalViewDetail from "./TerminalViewDetail";
import { fetchRequest as fetchReceipt } from "../../../store/receipt/actions";
import { fetchRequest as fetchCustomGroups } from "../../../store/customGroup/actions";
import { useEntityOrgConfig, useOrgConfig } from "../../../common/OrgConfigProvider";

interface LocationStateType {
  terminal?: Data;
  terminals?: Data[];
}

export default function TerminalView() {
  const location = useLocation();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const session = useSession();

  const terminalFromState = (): Data => {
    return (location.state as LocationStateType).terminal as Data;
  };

  const terminal = useSelector(
    id ? getById(id) : (): Data => terminalFromState()
  ) as Data;

  const { loaded: orgConfigLoaded } = useOrgConfig();
  const orgConfig = useEntityOrgConfig("terminal");

  useEffect(() => {
    if (!id || !orgConfigLoaded) return;
    dispatch(fetchTerminalDetail(id));
    dispatch(fetchReceipt(null));
    if (!orgConfig.hiddenFields.includes("Custom Groups")) {
      dispatch(fetchCustomGroups(null));
    }
  }, [id, orgConfigLoaded]);

  return (
    <Layout sessionData={session}>
      <main className={classes.content as string}>
        <div className={classes.appBarSpacer as string} />
        <Container maxWidth="lg" className={classes.container as string}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Terminal" />
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper as string}>
                {(!isNil(id) && isNil(terminal)) || !orgConfigLoaded ? (
                  <ProgressIndicator />
                ) : (
                  <Box position="relative">
                    <TerminalViewDetail
                      terminalData={terminal}
                      orgConfig={orgConfig}
                    />
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
